import { TasksPage } from './../tasks/tasks';
import { TasksProvider } from './../../providers/tasks/tasks';
import { Component } from '@angular/core';
import {
  NavController,
  NavParams,
  AlertController
} from 'ionic-angular';
import { TaskData } from '../../providers/tasks/models';
import { getValue } from '../../providers/tasks/filters';

@Component({
  selector: 'page-task-complete',
  templateUrl: 'task-complete.html'
})
export class TaskCompletePage {
  public task;
  private taskData: TaskData;
  public syncing: boolean = false;
  public syncingStatus: any = {
    title: 'Syncronising',
    message: 'connecting',
    percent: 0
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public tasksProvider: TasksProvider,
    public alertCtrl: AlertController
  ) {
    this.task = this.tasksProvider.getSelectedTask();
  }

  ionViewDidLoad() {}
  ionViewDidEnter() {
    const taskData = this.tasksProvider.getTaskData(this.task.id);
    // if(taskData.test) this.syncTasks();
    this.syncTasks();
  }

  syncTasks() {
    this.task = this.tasksProvider.getSelectedTask();
    this.taskData = this.tasksProvider.getTaskData(this.task.id);
    this.syncing = true;

    this.tasksProvider.syncTask(this.taskData, this.task).subscribe(
      data => {
        this.syncingStatus = data;
      },
      error => {
        this.syncing = false;
        this.syncingStatus = error.error;
        this.displayError(error);
      },
      () => {
        this.navCtrl.setRoot(TasksPage, {
          animate: true,
          direction: 'forward'
        });
      }
    );
  }

  displayError(err) {
    const errorObj = err;
    const message =
      err && err.status === 0
        ? 'There was an error communicating with the server. Check your internet connection and try again.'
        : getValue(errorObj,'error.message')
        ? errorObj.error.message
        : 'An unknown error occured. ';
    let alert = this.alertCtrl.create({
      title: 'Error',
      message: message,
      buttons: [
        {
          text: 'OK',
          role: 'ok',
          handler: data => {
            //this.afterError();
          }
        }
      ]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/task-complete/task-complete.ts